import { defineStyleConfig } from '@chakra-ui/react'

export const dividerTheme = defineStyleConfig({
    defaultProps: {
        // size: 'xl',
        // variant: 'thick',
        colorScheme: 'spikegray',
    },
})